





























































































































































































import Vue from 'vue'
import firebase from 'firebase'
import 'firebase/auth'
import { userAvatarImage } from '../../helper/constants'
import UserAvatar from '@/components/common/UserAvatar.vue'
import { adminMode } from '../../helper/permission.helper'
import { getThemeClasses, isAppInstalled } from '../../helper'
import MobileNavigation from './MobileNavigation.vue'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

import PWAAlertModal from '@/components/common/PWAAlertModal.vue'

export default Vue.extend({
  components: {
    UserAvatar,
    MobileNavigation,
    BaseIcon,
    PWAAlertModal
  },
  props: {
    logo: {
      type: String
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    alignment: {
      type: String,
      default: 'between'
    },
    backCallback: {
      type: Function
    }
  },
  data() {
    return {
      open: false,
      openSettings: false,
      headerRoot: {
        'product-overview': 'navigation-header',
        'post-overview': 'lesson-navigation-header'
      },
      headerContainer: {
        'product-overview': 'header',
        'post-overview': 'lesson-header'
      },
      showPWAAlert: false
    }
  },
  computed: {
    device(): string {
      return this.$store.getters.device
    },
    brandLogoUrl(): string {
      return this.logo || this.$store.state.logoUrl
    },
    userImage(): string {
      return this.$store.getters.userAvatar || userAvatarImage
    },
    isAdmin() {
      return adminMode()
    },
    libraryPath(): string {
      return 'library-v2'
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    isBuilder(): boolean {
      return this.$route.query.builder === 'true'
    },
    pwaAppSettings(): object {
      return this.$store.getters.pwaAppSettings
    },
    routeName(): string {
      return this.$route.name
    },
    isPWAInstalled() {
      return isAppInstalled()
    }
  },
  mounted() {
    this.capturePWAEvent()
  },
  methods: {
    signOut() {
      this.$cookies.remove('cat')
      if (localStorage) {
        try {
          localStorage.removeItem('cat')
        } catch (error) {
          // patch
        }
      }
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: 'login' })
        })
    },
    openModal() {
      this.$bus.$emit('openSearchModal', true)
    },
    capturePWAEvent() {
      window.addEventListener('beforeinstallprompt', event => {
        event.preventDefault()
        this.storePWAEvent(event)
      })
    },
    storePWAEvent(event) {
      this.$store.commit('SET_PWA_APP_SETTINGS', {
        addWithExisting: true,
        pwaEvent: event
      })
    },
    triggerPWAEvent() {
      this.openSettings = false
      if (this.pwaAppSettings && this.pwaAppSettings.pwaEvent) {
        this.pwaAppSettings.pwaEvent.prompt()
        return
      }
      this.showPWAAlert = true
    },
    closePWAAlert() {
      this.showPWAAlert = false
    },
    getThemeClasses
  }
})
